import { schema } from 'normalizr';

export const userSchema = new schema.Entity('users');
export const authenticationSchema = new schema.Entity('authentications', {
  user: userSchema,
});
export const announcementSchema = new schema.Entity('announcements');
export const modelIdsByBodyStyleIdsSchema = new schema.Entity(
  'modelIdsByBodyStyleIds',
);

export const seriesSchemaEntity = new schema.Entity('series', {
  modelIdsBodyStyleIds: [modelIdsByBodyStyleIdsSchema],
});
export const dashboardSchemaEntity = new schema.Entity('dashboard');

export const bodyStyleSchemaEntity = new schema.Entity('bodyStyles');
export const modelsSchemaEntity = new schema.Entity('models');

const templatesSchemaEntity = new schema.Entity('templates');
const templatesStateSchemaEntity = new schema.Entity('templatesStates');
const templatesSubmittedSchemaEntity = new schema.Entity('templateSubmitted');

const functionalGroupsSchemaEntity = new schema.Entity('functionalGroups', {
  templates: [templatesSchemaEntity],
});

export const functionalGroupCodeSchemaEntity = new schema.Entity(
  'functionalOptionCodeMappings',
);

const paintsSchemaEntity = new schema.Entity('paints');
const interiorsSchemaEntity = new schema.Entity('interiors');
const trimsSchemaEntity = new schema.Entity('trims');
const wheelsSchemaEntity = new schema.Entity('wheels');
const colorLinesSchemaEntity = new schema.Entity('colorLines');
const roofAndMirrorCapsSchemaEntity = new schema.Entity('roofAndMirrorCaps');

export const modelsWithTemplatesSpecsSchemaEntity = new schema.Entity(
  'models',
  {
    functionalGroups: [functionalGroupsSchemaEntity],
    availablePaints: [paintsSchemaEntity],
    availableInteriors: [interiorsSchemaEntity],
    availableTrims: [trimsSchemaEntity],
    availableWheels: [wheelsSchemaEntity],
    availableColorLines: [colorLinesSchemaEntity],
    availableRoofAndMirrorCaps: [roofAndMirrorCapsSchemaEntity],
    functionalOptionCodeMappings: [functionalGroupCodeSchemaEntity],
  },
);

export const modelsWithTemplatesWorkingState = new schema.Entity('modelState', {
  templatesWorkingState: [templatesStateSchemaEntity],
  templatesSubmitted: [templatesSubmittedSchemaEntity],
});

export const modelWithCurrentViewer = new schema.Entity('modelsViewers');

export const designOptionsSchema = new schema.Object({
  availablePaints: [paintsSchemaEntity],
  availableInteriors: [interiorsSchemaEntity],
  availableTrims: [trimsSchemaEntity],
  availableWheels: [wheelsSchemaEntity],
});

export const inCartModelsWithTemplatesSchemaEntity = new schema.Entity(
  'models',
  {
    functionalGroups: [functionalGroupsSchemaEntity],
  },
);
